import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig, sortOptions } from '../config'
import Sidebar from './Sidebar'
import MobileSidebar from './MobileSidebar'

export default ({ mobile }) => {
    const { loading, query, response, pageType } = useAppState()
    const { updateSearch } = useActions()

    const selectedFiltersCount =
        query.products?.filter?.reduce(
            (acc, curr) => acc + (Array.isArray(curr.value) ? curr.value.length : 1),
            0
        ) ?? 0
    const docCount = response.products?.total ?? 0

    const activeSort =
        sortOptions.find((option) =>
            option.value.sort.every((v1) =>
                query.products?.sort?.find((v2) => v1.field === v2.field && v1.order === v2.order)
            )
        )?.id ?? defaultConfig.sort.id

    return (
        <div
            class={
                mobile
                    ? 'ns-mobile-header-controls ns-d-flex ns-flex-column ns-flex-wrap align-center ns-justify-content-between ns-d-md-none ns-pt-o ns-pr-2 ns-pb-1'
                    : 'ns-header-controls ns-d-none ns-flex-wrap align-center ns-justify-content-between ns-d-md-flex ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2'
            }
            style={loading ? 'opacity: 0.3; justify-content: end !important;' : ''}>
            {/* {!loading && pageType !== 'category' && (
                <span class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-grey-dark"
                      data-nosto-element="totalResults">
                    '{query.query}' - {docCount} results
                </span>
            )} */}
            <div
                class={
                    mobile
                        ? 'ns-filters-container ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block ns-w-100 ns-my-4'
                        : 'ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block'
                }>
                {mobile && (
                    <>
                        <input type="checkbox" id="ns-facet-sidebar-toggle" class="ns-d-none" />
                        <label
                            for="ns-facet-sidebar-toggle"
                            style="position: relative;"
                            class="ns-filters-label ns-act-btn ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            <span>FILTERS</span>
                            {selectedFiltersCount > 0 && (
                                <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-2 ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                                    {selectedFiltersCount}
                                </span>
                            )}
                        </label>
                        <MobileSidebar />
                    </>
                )}
                {/* <div class="ns-relative nosto-hide-on-desktop nosto-dropdown-container">
                    <select
                        name="ns-sort-dropdown"
                        id="ns-sort-dropdown"
                        class="ns-selection-dropdown-menu ns-selection-dropdown-sort-menu ns-text-align-left"
                        value={activeSort}
                        onChange={(e) => {
                            updateSearch({
                                products: {
                                    sort: sortOptions.find(
                                        (v) => v.id === e?.target?.value
                                    )?.value?.sort,
                                },
                            })
                        }}
                    >
                        {sortOptions.map((o) => (
                            <option value={o.id}>{o.value.name}</option>
                        ))}
                    </select>
                </div> */}
            </div>
        </div>
    )
}
